import React from 'react';
type Props = {
	id: 'menuElement' | 'menuArrow' | 'greenElement';
};
const CategorySelectorSvg = ({id}: Props) => {
	switch (id) {
		case 'menuElement':
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="18"
					height="18"
					viewBox="0 0 18 18"
				>
					<g>
						<g>
							<g />
							<g>
								<path
									fill="#909090"
									d="M11.27 13.505V12.38h-4.5v1.125zm-6.75-4.5h9V7.88h-9zM2.27 3.38v1.125h13.5V3.38z"
								/>
							</g>
						</g>
					</g>
				</svg>
			);
		case 'menuArrow':
			return (
				<svg
					width="13"
					height="13"
					viewBox="0 0 13 13"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M11.1044 4.32722C11.0318 4.25635 10.9344 4.21667 10.833 4.21667C10.7316 4.21667 10.6342 4.25635 10.5616 4.32722L6.49992 8.28653L2.43904 4.32722C2.36649 4.25635 2.26909 4.21667 2.16767 4.21667C2.06624 4.21667 1.96885 4.25635 1.89629 4.32722C1.86091 4.36166 1.83279 4.40285 1.81359 4.44834C1.79439 4.49384 1.7845 4.54271 1.7845 4.59209C1.7845 4.64147 1.79439 4.69035 1.81359 4.73584C1.83279 4.78134 1.86091 4.82252 1.89629 4.85697L6.21635 9.06734C6.29222 9.14129 6.39397 9.18268 6.49992 9.18268C6.60586 9.18268 6.70761 9.14129 6.78348 9.06734L11.1035 4.85697C11.1389 4.82252 11.167 4.78134 11.1862 4.73584C11.2054 4.69035 11.2153 4.64147 11.2153 4.59209C11.2153 4.54271 11.2054 4.49384 11.1862 4.44834C11.167 4.40285 11.1389 4.36166 11.1035 4.32722H11.1044Z"
						fill="#7A934F"
					/>
				</svg>
			);
		case 'greenElement':
			return (
				<svg
					width="15"
					height="28"
					viewBox="0 0 15 28"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g clipPath="url(#clip0_1_12272)">
						<circle cx="1" cy="14" r="14" fill="#7A934F" />
					</g>
					<defs>
						<clipPath id="clip0_1_12272">
							<rect width="15" height="28" fill="white" />
						</clipPath>
					</defs>
				</svg>
			);

		default:
			return <svg />;
	}
};

export default CategorySelectorSvg;
